__turbopack_context__.v({
  "container": "nI_1rW_container",
  "content": "nI_1rW_content",
  "uploadButton": "nI_1rW_uploadButton",
});
